import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],
    failure: ["errorMessage"],
    reset: [],
  },
  {
    prefix: "DELETE_DOCUMENT_",
  }
);

export interface DeleteDocumentState {
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteDocumentRequestAction {
  id: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface DeleteDocumentFailureAction {
  errorMessage: string;
  validationErrors?: any;
}

const INITIAL_STATE: DeleteDocumentState = {
  loading: false,
  errorMessage: null,
};

const request = (state: DeleteDocumentState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteDocumentState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: DeleteDocumentState,
  action: DeleteDocumentFailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const reset = () => INITIAL_STATE;

export const deleteDocument = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteDocumentTypes = Types;
export const DeleteDocumentActions = Creators;
